import { epochSecondsToDate, z, type ZodType } from '@customerio/hydra-validation';
import type { Collection as UIAPICollection } from '@customerio/hydra-ui-api';
import { defineEntity } from '../shared/define-entity';

/* ------------------------------------------------------------------------- */
/* Type                                                                       */
/* ------------------------------------------------------------------------- */

export type Collection = Omit<UIAPICollection, 'id' | 'created_at' | 'updated_at'> & {
  id: string;
  created_at: Date;
  updated_at: Date;
};

/* ------------------------------------------------------------------------- */
/* Schema — only the transforms                                               */
/* ------------------------------------------------------------------------- */

const CollectionFromApi = z.looseObject({
  id: z.coerce.string(),
  created_at: epochSecondsToDate,
  updated_at: epochSecondsToDate,
}) as unknown as ZodType<Collection, unknown>;

/* ------------------------------------------------------------------------- */
/* Entity                                                                     */
/* ------------------------------------------------------------------------- */

/** @public */
export const collection = defineEntity<Collection, never, void, undefined, 'workspace'>({
  name: 'collection',
  scope: 'workspace',
  pk: (c) => c.id,
  schema: { read: CollectionFromApi },
});

export const collectionKeys = collection.keys;

export function parseCollection(raw: unknown): Collection {
  return collection.parse(raw);
}

/* ------------------------------------------------------------------------- */
/* Selectors                                                                  */
/* ------------------------------------------------------------------------- */

export function importIsInvalid(c: Pick<Collection, 'importing' | 'import_error' | 'rows'>): boolean {
  return !c.importing && (c.import_error?.length ?? 0) > 0 && c.rows === 0;
}
